var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAttachmentWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FCBB00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.191 26.093a.787.787 0 0 0 .523.193c.196 0 .384-.07.523-.193l7.118-6.347a.612.612 0 0 0 .191-.637.704.704 0 0 0-.523-.466.802.802 0 0 0-.714.17l-5.855 5.222V12.659c0-.364-.331-.659-.74-.659-.408 0-.74.295-.74.66v11.375l-5.855-5.222a.802.802 0 0 0-.714-.17.704.704 0 0 0-.523.466.612.612 0 0 0 .192.637l7.117 6.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 32h18.666c.177 0 .347-.09.472-.253.125-.162.195-.381.195-.61v-3.988c0-.477-.298-.863-.667-.863-.368 0-.666.386-.666.863v3.125H13.333v-3.125c0-.477-.298-.863-.666-.863-.369 0-.667.386-.667.863v3.988c0 .477.298.863.667.863Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAttachmentWhite);
export default __webpack_public_path__ + "static/media/download_attachment_white.3dd40c358a822a5fb51b85ce8c4727ef.svg";
export { ForwardRef as ReactComponent };